module.exports = __webpack_public_path__ + "static/img/3-4.e356d08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/3-4.png
// module id = SD7h
// module chunks = 0